export default {
    LOAD_PLAYERS(state, player) {
        state.items = player
    }
}